import {
    AGENDA_LIST,
    AGENDA_FULLLIST,
    AGENDA_FILTER,
    AGENDA_CREATE,
    AGENDA_CREATE_SUCCESS,
    AGENDA_LIST_SUCCESS,
    AGENDA_FULLLIST_SUCCESS,
    AGENDA_REQUEST_FAILED,
    AGENDA_UPDATE,
    AGENDA_UPDATE_SUCCESS,
    AGENDA_DELETE,
    AGENDA_DELETE_SUCCESS,
  } from "../agenda/actionTypes";
  
  const initialState = {
    agenda: [],
    agendaCreated: {},
    agendaUpdated: {},
    agendaDeleted:false,
    loading: false,
    error: "",
  };
  
  const agenda = (state = initialState, action) => {
    switch (action.type) {
      case AGENDA_CREATE:
        state = {
          ...state,
          loading: true,
        };
        break;
      case AGENDA_LIST:
        state = {
          ...state,
          loading: true,
        };
        break;
      case AGENDA_FULLLIST:
        state = {
          ...state,
          loading: true,
        };
        break;
      case AGENDA_FILTER:
        state = {
          ...state,
          loading: true,
        };
        break;
      case AGENDA_UPDATE:
        state = {
          ...state,
          loading: true,
        };
        break;
      case AGENDA_DELETE:
          state = {
            ...state,
            loading: true,
            agendaDeleted: false,
          };
          break;
      case AGENDA_CREATE_SUCCESS:
        state = {
          ...state,
          loading: false,
          agendaCreated: action.payload,
          error: "",
        };
        break;
      case AGENDA_LIST_SUCCESS:
        state = {
          ...state,
          loading: false,
          agenda: action.payload,
          agendaCreated: {},
          agendaUpdated: {},
          agendaDeleted: false,
          error: "",
        };
        break;
      case AGENDA_FULLLIST_SUCCESS:
        state = {
          ...state,
          loading: false,
          agenda: action.payload,
          agendaCreated: {},
          agendaDeleted: false,
          agendaUpdated:{},
          error: "",
        };
        break;
      case AGENDA_UPDATE_SUCCESS:
        state = {
          ...state,
          loading: false,
          agendaUpdated: action.payload,
          error: "",
        };
        break;
      case AGENDA_DELETE_SUCCESS:
        state = {
          ...state,
          loading: false,
          agendaDeleted: true,
          error: "",
        };
        break;
      case AGENDA_REQUEST_FAILED:
        state = {
          ...state,
          loading: false,
          error: action.payload,
        };
        break;
      default:
        state = { ...state };
        break;
    }
    return state;
  };
  
  export default agenda;
  